import { Result } from 'antd';
import React from 'react';

const AuctionResult: React.FC = () => {
  return (
    <Result
      status='success'
      title='Auction is over!'
      subTitle='Thank you for participating in the auction.'
    />
  );
};

export default AuctionResult;
